export default "__VITE_ASSET__CfHDBaB___"